/* Barrel Station UI system: menus, accordions and tabs. Native buttons and links only. */
(function () {
  if (window.BSUI) return;
  window.BSUI = true;

  function panelOf(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }

  function closeDisclosures(except) {
    document.querySelectorAll('[data-bs-disclosure][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = panelOf(b);
      if (p) p.hidden = true;
    });
  }

  function scrollParent(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;
  }

  // A-Z letter links inside a menu panel: move within the panel, never scroll the page behind it
  function jumpToLetter(e, link) {
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target || !target.closest('[data-bs-panel]')) return false;
    e.preventDefault();
    var box = scrollParent(target);
    if (box) box.scrollTop += target.getBoundingClientRect().top - box.getBoundingClientRect().top - 16;
    target.classList.remove('is-target');
    void target.offsetWidth;
    target.classList.add('is-target');
    clearTimeout(target.bsTimer);
    target.bsTimer = setTimeout(function () { target.classList.remove('is-target'); }, 1600);
    var first = target.querySelector('a[href]');
    if (first) first.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', function (e) {
    var letter = e.target.closest('.bs-letters a[href^="#"]');
    if (letter && jumpToLetter(e, letter)) return;
    var btn = e.target.closest('[data-bs-disclosure]');
    if (btn) {
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeDisclosures(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var p = panelOf(btn);
      if (p) p.hidden = open;
      return;
    }
    var acc = e.target.closest('[data-bs-accordion]');
    if (acc) {
      var isOpen = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var ap = panelOf(acc);
      if (ap) ap.hidden = isOpen;
      return;
    }
    if (!e.target.closest('[data-bs-panel]')) closeDisclosures();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openBtn = document.querySelector('[data-bs-disclosure][aria-expanded="true"]');
    if (openBtn) { closeDisclosures(); openBtn.focus(); }
  });

  // Close the brands menu when focus leaves the header entirely
  document.addEventListener('focusin', function (e) {
    var openBtn = document.querySelector('[data-bs-disclosure][aria-expanded="true"]');
    if (!openBtn) return;
    var scope = openBtn.closest('[data-bs-menu-scope]');
    if (scope && !scope.contains(e.target)) closeDisclosures();
  });

  // Product cards: add to cart without leaving the page, then open the theme's cart drawer.
  // Falls back to the normal form post when the theme is set to use the cart page instead of the drawer.
  function cardMessage(form, text, isError) {
    var msg = form.parentNode.querySelector('.bs-pcard__msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'bs-pcard__msg';
      msg.setAttribute('role', 'status');
      form.parentNode.insertBefore(msg, form.nextSibling);
    }
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
    msg.hidden = !text;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('bs-pcard__form')) return;
    if (!document.querySelector('[data-js-site-cart-sidebar]') || typeof window.refreshCart !== 'function' || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    cardMessage(form, '');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        window.refreshCart();
        btn.classList.add('bs-btn--added');
        btn.innerHTML = 'Added to cart';
        setTimeout(function () { btn.classList.remove('bs-btn--added'); btn.innerHTML = label; }, 2500);
      })
      .catch(function (err) {
        cardMessage(form, (err && (err.description || err.message)) || 'Sorry, this bottle could not be added. Please try again.', true);
      })
      .then(function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); });
  });

  function initTabs(root) {
    (root || document).querySelectorAll('[data-bs-tabs]').forEach(function (list) {
      if (list.dataset.bsReady) return;
      list.dataset.bsReady = '1';
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = panelOf(t);
          if (p) p.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (e.key === 'Home') d = -i;
          if (e.key === 'End') d = tabs.length - 1 - i;
          if (!d) return;
          e.preventDefault();
          var next = tabs[(i + d + tabs.length) % tabs.length];
          select(next);
          next.focus();
        });
      });
    });
  }

  // Theme drawers (<sidebar-drawer>: the phone menu and the cart). The theme opens and closes them and Escape closes
  // them; this adds the keyboard parts: focus moves into the drawer when it opens, Tab stays inside it while it's open,
  // and focus goes back to the button that opened it (menu, cart or Add to cart) when it closes.
  var drawerOpener = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button, a[href], [role="button"]');
    if (t && !t.closest('sidebar-drawer')) drawerOpener = t;
  }, true);
  function drawerFocusables(dr) {
    return Array.prototype.filter.call(dr.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'), function (n) {
      return n.offsetParent !== null && !n.closest('[hidden], [inert]');
    });
  }
  function watchDrawer(dr) {
    if (dr.bsWatched) return;
    dr.bsWatched = true;
    new MutationObserver(function () {
      var isOpen = dr.classList.contains('sidebar--opened');
      if (isOpen && !dr.bsOpen) {
        dr.bsOpen = true;
        dr.bsOpener = drawerOpener;
        setTimeout(function () {
          var target = dr.querySelector('[data-js-close]') || dr;
          try { target.focus({ preventScroll: true }); } catch (err) {}
        }, 60);
      } else if (!isOpen && dr.bsOpen) {
        dr.bsOpen = false;
        var back = dr.bsOpener && document.contains(dr.bsOpener) && dr.bsOpener.offsetParent !== null ? dr.bsOpener : document.querySelector('[aria-controls="' + dr.id + '"]');
        var a = document.activeElement;
        if (back && (!a || a === document.body || dr.contains(a))) {
          setTimeout(function () { try { back.focus({ preventScroll: true }); } catch (err) {} }, 30);
        }
      }
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }
  function watchDrawers() { document.querySelectorAll('sidebar-drawer').forEach(watchDrawer); }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var dr = document.querySelector('sidebar-drawer.sidebar--opened');
    if (!dr) return;
    var list = drawerFocusables(dr);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (!dr.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTabs(); watchDrawers(); });
  else { initTabs(); watchDrawers(); }
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); });
})();
